import styled, { css } from 'styled-components';

export const Wrapper = styled.main`
  margin: 105px auto;
  position: relative;
  width: 990px;

  @media screen and (max-width: 992px) {
    margin: 0 auto;
    width: 100%;
  }
`;

export const WrapperContainer = styled.div`
  margin: 0 auto;
  width: 930px;

  @media screen and (max-width: 992px) {
    margin: 0 auto;
    width: 89.333%;
  }
`;

export const hideOnMobile = css`
  @media screen and (max-width: 992px) {
    display: none;
  }
`;

export const labelText = css`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
`;

export const touchableText = css`
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;
